<template>
  <div class="flex flex-col">
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <router-link
      v-if="hasPermission('edit_expenses')"
      :to="{ name: 'expensesCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Egreso</router-link
    >

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Concepto</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Monto</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Fecha</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expense in expenses" :key="expense.id" class="table-row">
            <td class="table-cell">
              {{ expense.id }}
            </td>
            <td class="table-cell">{{ expense.expense_category.name }}</td>
            <td class="table-cell">
              {{ integerToCurrency(expense.amount) }}
            </td>
            <td class="table-cell">
              {{ formatDatetime(expense.date_time) }}
            </td>

            <td class="table-cell">
              <div class="flex space-x-2">
                <router-link
                  :to="{ name: 'expensesEditForm', params: { id: expense.id } }"
                >
                  <edit-button />
                </router-link>

                <delete-button
                  @click.prevent="
                    expenseToDelete = expense;
                    openDeleteModal();
                  "
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import Pagination from "@/components/ui/Pagination.vue";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Expenses",

  components: {
    Pagination,
  },

  data() {
    return {
      expenses: null,
      loading: false,
      loadingDelete: false,
      expenseToDelete: null,
      currentPage: 1,
      totalPages: 0,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "accounting");

    this.loadExpenses();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadExpenses() {
      this.loading = true;

      try {
        const response = await api.expenses.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
        ]);
        this.expenses = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadExpenses();
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.expenses.delete(this.expenseToDelete.id);
        this.expenseToDelete = null;
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.loadExpenses();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>